import styled from 'styled-components';

const Divider = styled.hr<{ style?: React.CSSProperties & { '--space'?: string } }>`
    border: none;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.charcoal20};
    margin: var(--space, 40px) 0;
`;

export default Divider;
